import { render } from "./home.page.vue?vue&type=template&id=22253be4"
import script from "./home.page.vue?vue&type=script&lang=js"
export * from "./home.page.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programmazione\\Nodejs\\CallER\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__